<template>
  <div class="page product-con">
    <div class="main-pic" v-if="info.picture"><img :src="info.picture" /></div>
    <div class="nav acea-row row-between-wrapper" v-if="info.picture">
      <div class="money">
        ￥
        <div class="num" v-text="info.price"></div>
      </div>
      <div class="acea-row row-middle">
        <div class="times" v-if="info.endTime > new Date().getTime()">
          <div>
            {{
              info.endTime > new Date().getTime()
                ? "距活动结束仅剩"
                : "该活动已经结束"
            }}
          </div>
          <CountDown
            :is-day="true"
            :datatime="info.endTime"
            v-if="info.endTime"
          ></CountDown>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
    </div>
    <div class="acea-row row-between-wrapper stats-container">
      <div class="stat-title">{{ info.title }}</div>
      <div class="stats-list">
        <div class="stat-item">销量：{{ info.purchasedUser || 110 }}</div>
        <div class="stat-item">浏览量：{{ info.browseUser || 110 }}</div>
      </div>
    </div>

    <!-- 背景音乐控制按钮 -->
    <div class="music-control" @click="toggleMusic" v-if="info.ismusic == 0">
      <div class="music-icon" :class="{ playing: isMusicPlaying }">
        <div class="music-symbol">{{ isMusicPlaying ? "♪" : "♫" }}</div>
      </div>
    </div>

    <!-- 用户显示控制按钮 (使用齿轮图标) -->
    <div
      class="user-display-control"
      @click="toggleUserDisplay"
      v-if="info.ismusic == 0"
    >
      <div class="user-icon">
        <span class="iconfont">{{ showUserDisplay ? "♙" : "♨" }}</span>
      </div>
    </div>

    <!-- 已购人员展示区域 - 淡入淡出上下滚动，昵称和状态在同一行 -->
    <div
      class="purchasers-section"
      v-if="showUserDisplay && recentPurchasers.length > 0"
    >
      <div class="purchasers-container">
        <div class="purchaser-item" v-if="currentPurchaser">
          <div class="avatar-wrapper">
            <img
              :src="currentPurchaser.headimgurl"
              :alt="blurNickname(currentPurchaser.nickname)"
              class="purchaser-avatar"
            />
            <div class="purchaser-info">
              <div class="purchaser-name">
                {{ blurNickname(currentPurchaser.nickname) }}
              </div>
              <div class="purchaser-status">刚刚购买</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cover">
      <div
        class="main-content"
        v-html="info && info.content ? info.content : ''"
      ></div>

      <div class="product-intro" v-if="info && info.remark">
        <div class="title">购买须知</div>
        <div class="notes" v-html="formattedRemark(info.remark)"></div>
      </div>

      <div style="height: 1.2rem"></div>
      <div class="footer acea-row row-between-wrapper">
        <div class="item" @click="setShareInfoStatus">
          <div class="iconfont icon-fenxiang"></div>
          <div>分享</div>
        </div>
        <div class="item" @click="toKefu">
          <div class="iconfont icon-kefu"></div>
          <div>客服</div>
        </div>
        <div class="item" @click="toHome">
          <div class="iconfont icon-yonghu-xianxing"></div>
          <div>我的</div>
        </div>
        <div class="bnt acea-row">
          <div class="joinCart" @click="toSpread">推广赚钱</div>
          <div class="buy" @click="tapBuy">立即购买</div>
        </div>
      </div>
    </div>

    <action-sheet v-model="show" cancel-text="取消" close-on-click-action>
      <van-notice-bar
        wrapable
        :scrollable="false"
        :text="`请输入正确的姓名和联系方式，方便为您同步创建会员信息；如果您已经是【${
          info && info.shopName ? info.shopName : ''
        }】门店的会员,还未绑定公众号，请在支付后联系门店绑定处理。`"
      />
      <div class="content">
        <field
          v-model="member.trueName"
          label="姓名"
          placeholder="请输入您的姓名"
          required
          error-message="请输入您的姓名"
        />
        <field
          v-model="member.phone"
          label="电话"
          placeholder="请输入您的电话号码"
          required
          error-message="请输入您的电话号码"
        />
        <field
          v-model="member.address"
          label="地址"
          placeholder="请输入您的地址"
          required
          error-message="请输入您的地址"
          v-if="info && info.postage == 1"
        />
        <van-button round block class="btn-buy" @click="doConfirm"
          >同意开通会员，并支付</van-button
        >
      </div>
    </action-sheet>
    <action-sheet v-model="kfshow" cancel-text="取消" close-on-click-action>
      <div class="content">
        <a :href="'tel:' + (info && info.phone ? info.phone : '')">{{
          info && info.phone ? info.phone : ""
        }}</a>
      </div>
    </action-sheet>

    <share-info
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></share-info>

    <!-- 背景音乐元素 -->
    <audio
      ref="bgMusic"
      :src="bgMusicUrl"
      loop
      v-if="info.ismusic == 0"
    ></audio>
  </div>
</template>

<script>
import { ActionSheet, Button as VanButton, Field, Toast } from "vant";
import ShareInfo from "@components/ShareInfo";
import { isWeixin, parseQuery } from "@utils";
import { get, createOrder, fetchBrowseUser } from "@api/activity";
import { openShareAll, pay } from "@libs/wechat";
import { mapGetters } from "vuex";
import { getShopUser } from "@api/user";
import CountDown from "@components/CountDown.vue";

export default {
  components: {
    CountDown,
    ActionSheet,
    Field,
    VanButton,
    ShareInfo,
  },
  props: {},
  data: function () {
    return {
      toBuy: false,
      kfshow: false,
      show: false,
      shareInfoStatus: false,
      id: this.$route.params.id,
      account: {},
      info: {}, // 初始化为空对象
      member: {
        trueName: "",
        phone: "",
      },
      isMusicPlaying: false,
      showUserDisplay: false, // 用户显示控制变量
      // 默认音乐URL
      defaultMusicUrl: "https://stream.556600.com/X/tu_zi_wu_kai_chang892.mp3",
      // 参与用户数据
      recentPurchasers: [],
      currentPurchaserIndex: 0,
      purchaserRotationTimer: null, // 添加定时器引用
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    bgMusicUrl() {
      return this.info && this.info.ismusic == 0 && this.info.musicUrl
        ? this.info.musicUrl
        : this.defaultMusicUrl;
    },
    currentPurchaser() {
      return this.recentPurchasers[this.currentPurchaserIndex];
    },
  },
  mounted: function () {
    this.getActive();
    this.getBrowseUser();
    this.startPurchaserRotation();
  },
  beforeDestroy() {
    // 清除定时器
    if (this.purchaserRotationTimer) {
      clearInterval(this.purchaserRotationTimer);
    }
  },
  methods: {
    toHome() {
      this.$router.push({ path: `/activity/promotion/${this.id}` });
    },
    toSpread() {
      this.$router.push({ path: `/activity/poster/${this.id}` });
    },
    toKefu() {
      this.kfshow = true;
    },
    setShareInfoStatus: function () {
      this.shareInfoStatus = !this.shareInfoStatus;
    },
    getShopUser() {
      if (!this.info || !this.info.shopId) return;
      getShopUser(this.info.shopId, this.userInfo.openid)
        .then((resp) => {
          this.account = resp.result || {};
        })
        .catch((e) => {
          console.log("获取用户信息失败:", e);
        });
    },
    getActive() {
      get(this.id)
        .then((resp) => {
          this.info = resp.result || {};
          document.title = this.info && this.info.title ? this.info.title : "";
          this.initShare();
          this.getShopUser();

          this.$nextTick(() => {
            this.showUserDisplay = this.info.ismusic == 0;
            this.playMusic();
          });
        })
        .catch((error) => {
          console.error("获取活动信息失败:", error);
          this.info = {};
        });
    },
    getBrowseUser() {
      fetchBrowseUser(this.id).then((resp) => {
        this.recentPurchasers = resp.result || [];
      });
    },

    tapBuy() {
      if (!this.info) {
        return Toast("活动信息加载中，请稍后...");
      }

      if (new Date().getTime() < this.info.startTime) {
        Toast("对不起，活动还没开始！！");
      } else if (new Date().getTime() > this.info.endTime) {
        Toast("对不起，活动已经结束！！");
      } else if (!this.account.id) {
        this.show = true;
      } else {
        this.member.trueName = this.account.trueName;
        this.member.phone = this.account.phone;
        this.createOrder();
      }
    },
    doConfirm() {
      if (this.member.trueName === "" || this.member.phone === "") {
        return Toast("请填写联系人或联系人电话");
      }
      if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.member.phone)) {
        return Toast("请填写正确的手机号");
      }
      if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.member.trueName)) {
        return Toast("请填写您的真实姓名");
      }
      if (this.info && this.info.postage == 1 && !this.member.address) {
        return Toast("请填写您的地址");
      }
      this.createOrder();
    },
    createOrder() {
      Toast.loading({ message: "生成订单中", forbidClick: true });
      let order = {
        companyId: this.info.companyId,
        shopId: this.info.shopId,
        openId: this.userInfo.openid,
        nickname: this.userInfo.nickname,
        memberId: this.account.id,
        memberName: this.member.trueName,
        memberPhone: this.member.phone,
        memberAddress: this.member.address,
        memberIcon: this.userInfo.picture,
        comboId: this.info.comboId,
        comboName: this.info.comboName,
        title: this.info.title,
        price: this.info.price,
        totalAmount: this.info.price,
        payAmount: this.info.price,
        smsId: this.info.id,
        num: 1,
        smsType: 1,
        picture: "",
      };

      let query = parseQuery();
      let urlSpread = query["spread"];

      // 不能推广自己：分享链接里的 spread 就是本人时不上传（服务端 initSpread 亦有校验）
      if (urlSpread && String(urlSpread) !== String(this.userInfo.id)) {
        order.spreadId = urlSpread;
      }

      createOrder(order)
        .then((res) => {
          if (res.code === 200) {
            pay(res.result)
              .then(() => {
                this.show = false;
                if (this.account.id) {
                  Toast("恭喜你，支付成功！");
                  this.$router.replace({ path: "/user" });
                } else {
                  Toast("恭喜你，支付成功,请及时关注公众号，以便接收消费消息！");
                  this.$router.replace({ path: "/user/subscribe" });
                }
              })
              .catch(() => {
                // 用户取消或支付失败：不得提示成功，订单以服务端支付回调为准
                this.show = false;
                Toast("支付未完成，如已扣款请稍后在“我的订单”中查看");
              });
          } else {
            Toast.fail(res.message || "创建订单失败");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast.fail(err.msg || "创建订单失败");
        });
    },
    initShare: function () {
      if (isWeixin() && this.info) {
        let configAppMessage = {
          title:
            this.userInfo.nickname + " 邀请您参加 " + (this.info.title || ""),
          desc: this.info.resume || "",
          link:
            location.origin + location.pathname + "?spread=" + this.userInfo.id,
          imgUrl: this.info.spreadImages,
        };
        console.info(configAppMessage);
        openShareAll(configAppMessage);
      }
    },
    // 控制音乐播放/暂停
    toggleMusic() {
      const bgMusic = this.$refs.bgMusic;
      if (this.isMusicPlaying) {
        bgMusic.pause();
      } else {
        bgMusic.play().catch((e) => {
          console.log("音乐播放失败:", e);
        });
      }
      this.isMusicPlaying = !this.isMusicPlaying;
    },
    // 播放音乐
    playMusic() {
      const bgMusic = this.$refs.bgMusic;
      if (bgMusic) {
        bgMusic
          .play()
          .then(() => {
            this.isMusicPlaying = true;
          })
          .catch((e) => {
            console.log("音乐播放失败:", e);
            this.isMusicPlaying = false;
          });
      }
    },
    // 模糊处理昵称
    blurNickname(nickname) {
      if (!nickname) return "";
      if (nickname.length === 1) return "*";
      return nickname.charAt(0) + "*".repeat(nickname.length - 1);
    },
    // 开始轮播已购人员
    startPurchaserRotation() {
      this.purchaserRotationTimer = setInterval(() => {
        this.nextPurchaser();
      }, 3000);
    },
    // 切换到下一个购买者
    nextPurchaser() {
      if (this.recentPurchasers.length > 0) {
        this.currentPurchaserIndex =
          (this.currentPurchaserIndex + 1) % this.recentPurchasers.length;
      }
    },
    // 切换用户显示状态
    toggleUserDisplay() {
      this.showUserDisplay = !this.showUserDisplay;
    },
    formattedRemark(text) {
      if (!text) return "";
      return text.replace(/\n/g, "<br>");
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background-color: #f5f5f5;
  position: relative;

  .main-pic {
    img {
      width: 100%;
    }
  }

  .nav {
    padding: 0 0.125rem;
    height: 1.125rem;

    .money {
      display: flex;
      align-items: flex-end;

      .num {
        font-size: 0.628rem;
        margin-bottom: -0.125rem;
      }

      .state {
        font-size: 0.24rem;
        margin-left: 0.15rem;
      }
    }
  }

  // 人数统计样式
  .stats-container {
    background-color: #ffffff;
    padding: 0.175rem 0.125rem 0.125rem;
    width: 100%;
    margin-bottom: 10px;

    .stat-title {
      font-size: 16px;
      font-weight: bold;
      display: block;
      flex: 1;
      width: 100%;
    }

    .stats-list {
      display: flex;
      margin: 0.085rem 0 0.125rem;
      justify-content: space-between;
      font-size: 12px;
      width: 100%;

      .stat-item {
        text-align: center;
        color: #82848f;
      }
    }
  }

  // 用户滚动展示样式
  .users-scroll-container {
    margin: 20px;

    .scroll-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }

    .users-scroll {
      height: 150px;
      overflow: hidden;
      position: relative;
      background: #fff;
      border-radius: 8px;
      padding: 10px 0;

      .users-track {
        position: absolute;
        width: 100%;
        top: 100%;

        &.animate {
          animation: scroll-up 10s linear infinite;
        }

        .user-item {
          display: flex;
          align-items: center;
          padding: 8px 15px;
          width: 100%;
          box-sizing: border-box;

          .user-avatar {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 10px;
          }

          .user-nickname {
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
  }

  // 垂直滚动动画
  @keyframes scroll-up {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-100%);
    }
  }

  .main-content {
    display: block;
    box-sizing: border-box;
    position: relative;
    padding: 0.25rem;
    line-height: 26px;
    background-color: #ffffff;

    ::v-deep img {
      display: block;
      max-width: 100% !important;
      height: auto;
      object-fit: contain;
    }
  }

  .footer .icon-shoucang1 {
    color: #e93323;
  }

  .content {
    padding: 20px 15px;

    .btn-buy {
      margin-top: 15px;
      color: #fff;
      background-color: #e93323;
    }
  }

  // 音乐控制按钮样式
  .music-control {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

    .music-icon {
      font-size: 20px;
      color: white;
      transition: transform 0.3s ease;

      &.playing {
        animation: rotate 3s linear infinite;
      }

      .music-symbol {
        font-size: 20px;
      }
    }
  }

  // 用户显示控制按钮样式 (齿轮图标)
  .user-display-control {
    position: fixed;
    top: 70px; /* 位于音乐按钮下方 */
    right: 20px;
    z-index: 1000;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

    .user-icon {
      font-size: 20px;
      color: white;
    }
  }

  // 已购人员展示区域样式 - 淡入淡出上下滚动，昵称和状态在同一行
  .purchasers-section {
    position: fixed;
    top: 20px;
    left: 20px;
    z-index: 999;
    width: 180px;
    overflow: hidden;

    .purchasers-container {
      position: relative;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 25px;
      padding: 5px 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

      .purchaser-item {
        display: flex;
        align-items: center;
        animation: fade-slide 3s infinite;

        .avatar-wrapper {
          display: flex;
          align-items: center;
          width: 100%;

          .purchaser-avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 10px;
          }

          .purchaser-info {
            display: flex;
            flex-direction: row; // 水平排列
            align-items: center;
            gap: 5px; // 元素间距

            .purchaser-name {
              font-size: 13px;
              color: #fff;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 80px;
            }

            .purchaser-status {
              font-size: 13px;
              color: #fff;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  // 淡入淡出上下滚动动画
  @keyframes fade-slide {
    0%,
    100% {
      opacity: 0;
      transform: translateY(10px);
    }
    20%,
    80% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // 音乐图标旋转动画
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.2rem;
    background-color: #fff;
    padding: 0 0.25rem;
    border-top: 1px solid #eee;
    z-index: 99;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 10%;

      .iconfont {
        font-size: 0.4rem;
        margin-bottom: 0.05rem;
        color: #666;
      }

      div {
        font-size: 0.24rem;
        color: #666;
      }
    }

    .bnt {
      width: 58%;
      height: 0.8rem;
      margin-top: 0.125rem;
      border-radius: 0.4rem;
      overflow: hidden;

      .joinCart {
        width: 50%;
        height: 100%;
        background-color: #fff;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.28rem;
      }

      .buy {
        width: 50%;
        height: 100%;
        background-color: #e93323;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.28rem;
      }
    }
  }

  .product-intro {
    background-color: #ffffff;
    padding: 0.25rem;
    margin-top: 0.2rem;

    .title {
      font-size: 0.36rem;
      font-weight: bold;
      margin-bottom: 0.2rem;
      color: #333;
    }

    .notes {
      font-size: 0.28rem;
      color: #666;
      line-height: 0.48rem;
    }
  }
}
</style>
